import React from "react";
import "./TimeToGrowthDurationEstimate.scss";

interface TimeToGrowthDurationEstimateProps {
  duration: number | string;
  warning?: boolean;
  timeToGrowthIcon?: string;
  timeAssignedIcon?: string;
  variant?: "default" | "resource-card";
}

const TimeToGrowthDurationEstimate: React.FC<
  TimeToGrowthDurationEstimateProps
> = ({
  duration,
  warning,
  timeToGrowthIcon,
  timeAssignedIcon,
  variant = "default",
}) => {
  return (
    <div
      className={`time-to-growth-duration-estimate d-flex align-items-center px-2 ${warning ? "warning" : ""} ${variant === "resource-card" ? "resource-card" : ""}`}
    >
      <div className="time-to-growth-duration-estimate-icon d-flex justify-content-center align-items-center">
        {timeToGrowthIcon && (
          <img
            src={timeToGrowthIcon}
            alt="time to growth"
            className="stopwatch-icon"
          />
        )}
        {timeAssignedIcon && (
          <img
            src={timeAssignedIcon}
            alt="stopwatch"
            className="stopwatch-icon"
          />
        )}
      </div>
      <div className="time-to-growth-duration-estimate-time-container d-flex align-items-center justify-content-center">
        <span className="time-to-growth-duration-estimate-time d-flex align-items-center justify-content-center mx-1">
          {duration}
        </span>
        <span className="time-to-growth-duration-estimate-time-unit">mins</span>
      </div>
    </div>
  );
};

export default TimeToGrowthDurationEstimate;
